import axios from "../../util/axios";

export default {
    /** 查询列表 */
    queryList: (data) => axios.get({url: "/wx/quotation/xbot/solution/queryList", data}),
    /**查询全部*/
    queryAll: () => axios.get({url: "/wx/quotation/xbot/solution/queryAll",}),
    /** 详情 */
    findById: (id) => axios.get({url: "/wx/quotation/xbot/solution/findById", data: {id}}),
    /** 按客户查询 */
    queryListByBtype: (data) => axios.get({url: "/wx/quotation/xbot/solution/queryListByBtype", data}),
    /** 删除关联 */
    deleteRelation: (id) => axios.del({url: "/wx/quotation/xbot/solution/deleteRelation", data: {id}}),
    /** 添加关联 */
    addRelation: (templateId, customerIds) => axios.post({url: `/wx/quotation/xbot/solution/addRelation?templateId=${templateId}`, data: customerIds}),
    /** 查询一个模板下的全部客户 */
    queryAllBtypeList: (templateId) => axios.get({url: `/wx/quotation/xbot/solution/queryAllBtypeList`, data: {templateId}}),
    /** 保存 */
    saveTemplate: (data) => axios.post({url: "/wx/quotation/xbot/solution/saveTemplate", data}),
    /** 删除模板 */
    deleteTemplate: (id) => axios.del({url: "/wx/quotation/xbot/solution/deleteTemplate", data: {id}}),
    /** 删除规则 */
    deleteRule: (id) => axios.del({url: "/wx/quotation/xbot/solution/deleteRule", data: {id}}),
    /** 商品分类 */
    queryPtypeCategory: () => axios.get({url: "/wx/quotation/xbot/solution/queryPtypeCategory"}),
    /** 分页查询商品 */
    queryPtypeByPage: (data) => axios.get({url: "/wx/quotation/xbot/solution/queryPtypeByPage", data}),
    /** 按id查询下级全部商品 */
    queryAllPtypeByParentId: (parentId) => axios.get({url: "/wx/quotation/xbot/solution/queryAllPtypeByParentId", data: {parentId}}),
    /** 往来单位分类 */
    queryBtypeCategory: () => axios.get({url: "/wx/quotation/xbot/solution/queryBtypeCategory"}),
    /** 往来单位列表 */
    queryBtypeByPage: (data) => axios.get({url: "/wx/quotation/xbot/solution/queryBtypeByPage", data}),
    /** 按id查询下级全部客户 */
    queryAllBtypeByParentId: (parentId) => axios.get({url: "/wx/quotation/xbot/solution/queryAllBtypeByParentId", data: {parentId}}),
    /**智能识别*/
    solutionRecognize: (data) => axios.post({url: "/wx/quotation/xbot/solution/solutionRecognize", data}),

}